import React, { useState } from 'react';
import { Package, Search, Filter, Plus, ArrowUpRight, ArrowDownRight, History, AlertCircle, MoreVertical, Edit2, Trash2, X as CloseIcon, Tag, DollarSign, Layers } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function InventoryMgmtView() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [inventory, setInventory] = useState([{
    id: 1,
    name: 'Atlantic Salmon',
    category: 'Seafood',
    stock: '4.2 lbs',
    unit: 'lbs',
    status: 'Low Stock',
    price: '$18.50'
  }, {
    id: 2,
    name: 'Heavy Cream',
    category: 'Dairy',
    stock: '2 qts',
    unit: 'qts',
    status: 'Low Stock',
    price: '$4.20'
  }, {
    id: 3,
    name: 'Brioche Buns',
    category: 'Bakery',
    stock: '12 units',
    unit: 'units',
    status: 'Critical',
    price: '$0.85'
  }, {
    id: 4,
    name: 'Ribeye Steak',
    category: 'Meat',
    stock: '45 lbs',
    unit: 'lbs',
    status: 'In Stock',
    price: '$22.00'
  }, {
    id: 5,
    name: 'Yukon Gold Potatoes',
    category: 'Produce',
    stock: '120 lbs',
    unit: 'lbs',
    status: 'In Stock',
    price: '$1.10'
  }, {
    id: 6,
    name: 'Extra Virgin Olive Oil',
    category: 'Dry Goods',
    stock: '15 liters',
    unit: 'liters',
    status: 'In Stock',
    price: '$12.50'
  }]);
  return <div className="space-y-6" data-id="element-306">
      {/* Add Item Modal */}
      <AnimatePresence data-id="element-307">
        {showAddModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4" data-id="element-308">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} className="w-full max-w-lg bg-white rounded-[32px] shadow-2xl overflow-hidden" data-id="element-309">
              <div className="p-8" data-id="element-310">
                <div className="flex justify-between items-start mb-8" data-id="element-311">
                  <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center text-emerald-600" data-id="element-312">
                    <Plus size={24} data-id="element-313" />
                  </div>
                  <button onClick={() => setShowAddModal(false)} className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-400" data-id="element-314">
                    <CloseIcon size={20} data-id="element-315" />
                  </button>
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-316">
                  Add New Inventory Item
                </h3>
                <p className="text-slate-500 text-sm mb-8" data-id="element-317">
                  Enter the details of the new item to track in your inventory.
                </p>

                <div className="space-y-4 mb-8" data-id="element-318">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-319">
                    <div className="md:col-span-2" data-id="element-320">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-321">
                        Item Name
                      </label>
                      <div className="relative" data-id="element-322">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-323">
                          <Tag size={18} className="text-slate-400" data-id="element-324" />
                        </div>
                        <input type="text" placeholder="e.g. Atlantic Salmon" className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all" data-id="element-325" />
                      </div>
                    </div>

                    <div data-id="element-326">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-327">
                        Category
                      </label>
                      <div className="relative" data-id="element-328">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-329">
                          <Layers size={18} className="text-slate-400" data-id="element-330" />
                        </div>
                        <select className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all appearance-none" data-id="element-331">
                          <option data-id="element-332">Seafood</option>
                          <option data-id="element-333">Meat</option>
                          <option data-id="element-334">Produce</option>
                          <option data-id="element-335">Dairy</option>
                          <option data-id="element-336">Bakery</option>
                          <option data-id="element-337">Dry Goods</option>
                        </select>
                      </div>
                    </div>

                    <div data-id="element-338">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-339">
                        Unit Price
                      </label>
                      <div className="relative" data-id="element-340">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-341">
                          <DollarSign size={18} className="text-slate-400" data-id="element-342" />
                        </div>
                        <input type="number" placeholder="0.00" className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all" data-id="element-343" />
                      </div>
                    </div>

                    <div data-id="element-344">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-345">
                        Initial Stock
                      </label>
                      <input type="number" placeholder="0" className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all" data-id="element-346" />
                    </div>

                    <div data-id="element-347">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-348">
                        Unit Type
                      </label>
                      <select className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all appearance-none" data-id="element-349">
                        <option data-id="element-350">lbs</option>
                        <option data-id="element-351">oz</option>
                        <option data-id="element-352">units</option>
                        <option data-id="element-353">qts</option>
                        <option data-id="element-354">liters</option>
                        <option data-id="element-355">cases</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="flex gap-3" data-id="element-356">
                  <button onClick={() => setShowAddModal(false)} className="flex-1 py-3 px-4 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl text-sm font-bold transition-all" data-id="element-357">
                    Cancel
                  </button>
                  <button onClick={() => setShowAddModal(false)} className="flex-1 py-3 px-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 transition-all" data-id="element-358">
                    Add to Inventory
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <div className="flex items-center justify-between" data-id="element-359">
        <div data-id="element-360">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-361">
            Inventory Management System
          </h2>
          <p className="text-sm text-slate-500" data-id="element-362">
            Real-time stock tracking and replenishment
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-363">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-364">
            <History size={14} data-id="element-365" />
            Audit Log
          </button>
          <button onClick={() => setShowAddModal(true)} className="flex items-center gap-2 px-6 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 hover:bg-emerald-600 transition-all" data-id="element-366">
            <Plus size={16} data-id="element-367" />
            Add Item
          </button>
        </div>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-368">
        <StatCard title="Total Items" value="1,240" icon={Package} color="blue" data-id="element-369" />
        <StatCard title="Low Stock Alerts" value="12" icon={AlertCircle} color="amber" data-id="element-370" />
        <StatCard title="Inventory Value" value="$42,500" icon={ArrowUpRight} color="emerald" data-id="element-371" />
      </div>

      {/* Inventory Table */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-372">
        <div className="p-4 border-b border-slate-50 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-373">
          <div className="relative flex-1 max-w-md" data-id="element-374">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-375" />
            <input type="text" placeholder="Search inventory by name, category, or SKU..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-emerald-500/10 focus:border-emerald-500 outline-none transition-all" data-id="element-376" />
          </div>
          <div className="flex items-center gap-2" data-id="element-377">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-378">
              <Filter size={18} data-id="element-379" />
            </button>
            <div className="h-4 w-[1px] bg-slate-200 mx-1" data-id="element-380" />
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-381">
              Showing {inventory.length} Items
            </p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-382">
          <table className="w-full text-left" data-id="element-383">
            <thead data-id="element-384">
              <tr className="bg-slate-50/50" data-id="element-385">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-386">
                  Item Name
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-387">
                  Category
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-388">
                  Stock Level
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-389">
                  Unit Price
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-390">
                  Status
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-391">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-392">
              {inventory.map(item => <tr key={item.id} className="hover:bg-slate-50 transition-colors group" data-id="element-393">
                  <td className="px-6 py-4" data-id="element-394">
                    <span className="text-sm font-bold text-slate-900" data-id="element-395">
                      {item.name}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-396">
                    <span className="px-2 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold rounded-md uppercase" data-id="element-397">
                      {item.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-398">
                    {item.stock}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-500" data-id="element-399">
                    {item.price}
                  </td>
                  <td className="px-6 py-4" data-id="element-400">
                    <span className={`flex items-center gap-1.5 text-[10px] font-bold ${item.status === 'In Stock' ? 'text-emerald-600' : item.status === 'Low Stock' ? 'text-amber-600' : 'text-rose-600'}`} data-id="element-401">
                      <div className={`w-1.5 h-1.5 rounded-full ${item.status === 'In Stock' ? 'bg-emerald-500' : item.status === 'Low Stock' ? 'bg-amber-500' : 'bg-rose-500'}`} data-id="element-402" />
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-403">
                    <div className="flex items-center justify-end gap-1" data-id="element-404">
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-405">
                        <Edit2 size={14} data-id="element-406" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-407">
                        <Trash2 size={14} data-id="element-408" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-409">
                        <MoreVertical size={14} data-id="element-410" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  icon: Icon,
  color
}: any) {
  const colors: any = {
    emerald: 'bg-emerald-50 text-emerald-600',
    blue: 'bg-blue-50 text-blue-600',
    amber: 'bg-amber-50 text-amber-600'
  };
  return <div className="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm" data-id="element-411">
      <div className="flex items-center gap-4" data-id="element-412">
        <div className={`p-3 rounded-xl ${colors[color]}`} data-id="element-413">
          <Icon size={20} data-id="element-414" />
        </div>
        <div data-id="element-415">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-416">
            {title}
          </p>
          <p className="text-xl font-black text-slate-900" data-id="element-417">{value}</p>
        </div>
      </div>
    </div>;
}